import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../../components/Layout';
import Content from '../../../../components/Pages/Marathons/Results/Stage';

const { displayName } = config;

function MarathonResultStage(): React.JSX.Element {
  document.title = `${displayName} Голосование`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default MarathonResultStage;
